import React from 'react';
import {useState} from 'react';
import connect from 'react-redux/es/connect/connect';
import {cartActions} from '../../../../_actions';
import {authentication} from '../../../../_reducers/authentication.reducer';
import AddToCartDialog from '../../../ProductList/components/AddToCartDialog/AddToCartDialog';
import AnalogInStock from '../AnalogInStock';

const TabPaneRelatedProducts = props => {
  const {
    searchStatus,
    listSearchRelated,
    currencyMainContr,
    currencyMain,
    customer_data,
    addToCart,
    resultsMod,
  } = props;

  const [dialogData, setDialogData] = useState({});

  const customer_group_id = customer_data && customer_data.discount_group_id;

  const handleClose = props => {
    const {offers, localMainCartId} = props;
    if (offers) {
      Object.keys(offers).map(
        key =>
          offers[key].quantity > 0 &&
          addToCart(
            localMainCartId,
            key,
            offers[key].price,
            offers[key].quantity,
          ),
      );
    }
    setDialogData({});
  };
  return (
    <div>
      {searchStatus.loading === false &&
        listSearchRelated.results &&
        listSearchRelated.results.length > 0 && (
          <AnalogInStock setDialogData={setDialogData} list={resultsMod} />
        )}
      <AddToCartDialog
        dialogData={dialogData}
        handleClose={handleClose}
        currencyMainContr={currencyMainContr}
        currencyMain={currencyMain}
        customerGroupId={customer_group_id}
        authentication={authentication}
        discountsByProduct={
          dialogData.row && dialogData.row.discounts_by_quantity_sum_of_order
            ? dialogData.row.discounts_by_quantity_sum_of_order
            : dialogData.row && dialogData.row.balance[0] !== undefined
            ? dialogData.row &&
              dialogData.row.balance[0].discounts_by_quantity_sum_of_order
            : ''
        }
      />
    </div>
  );
};

const mapState = state => {
  const {searchStatus, listSearchRelated} = state;
  const {customer_data} = state.contragentData;

  return {
    searchStatus,
    listSearchRelated,
    customer_data,
  };
};
const actionCreators = {
  addToCart: cartActions.addToCart,
};
export default connect(mapState, actionCreators)(TabPaneRelatedProducts);
